import { Button, Col, Divider, message, Row } from "antd";
import React from "react";
import ProductSearch from "./product.search";
import TableItems from "./items.table";
import { useHardPromotionFormMutate } from "../contexts/hard-promotion-form.context";
import _ from "lodash";

const TYPE = "items";
const PanelItems = () => {
  const {
    state: {
      data: { items },
    },
    dispatch,
  } = useHardPromotionFormMutate();

  const handleSelectProduct = (product_code, option) => {
    if (_.find(items || [], (n) => n.product_code === product_code))
      return message.warning("มีสินค้านี้ในรายการแล้ว");
    dispatch({
      type: "ADD_ITEM",
      payload: { type: TYPE, product_code, product_name: option?.props.label },
    });
  };

  return (
    <>
      <Divider>สินค้าในเงื่อนไข</Divider>
      <Row gutter={16} className="mb-2">
        <Col md={20}>
          <ProductSearch onSelect={handleSelectProduct} />
        </Col>
        <Col md={4}>
          <Button
            block
            type="primary"
            ghost
            onClick={() => {
              dispatch({ type: "OPEN_MODAL", payload: { name: "clone" } });
            }}
          >
            คัดลอก
          </Button>
        </Col>
      </Row>
      <TableItems />
    </>
  );
};

export default PanelItems;
